// extracted by mini-css-extract-plugin
export default {"geoRevTableRow":"RevSegTable_geoRevTableRow__vuQEB","geoRevTableLabelCell":"RevSegTable_geoRevTableLabelCell__kK2Po","geoRevTableValueCell":"RevSegTable_geoRevTableValueCell__jrf7V"};